// extracted by mini-css-extract-plugin
module.exports = {"container":"PreviewProductsMobile_container__1kFFH","productCardContainer":"PreviewProductsMobile_productCardContainer__3EOA8","carousel":"PreviewProductsMobile_carousel__2Iit2"};